import { isTelegramApp } from '@/utils/isTelegramApp';

export const storage = {
  async getItem(key: string): Promise<string | null> {
    if (isTelegramApp()) {
      const { cloudStorage } = await import('@telegram-apps/sdk-react');
      return await cloudStorage.getItem(key);
    } else {
      return localStorage.getItem(key) || '';
    }
  },

  async setItem(key: string, value: string): Promise<void> {
    if (isTelegramApp()) {
      const { cloudStorage } = await import('@telegram-apps/sdk-react');
      await cloudStorage.setItem(key, value);
    } else {
      localStorage.setItem(key, value);
    }
  },

  async removeItem(key: string): Promise<void> {
    if (isTelegramApp()) {
      const { cloudStorage } = await import('@telegram-apps/sdk-react');
      await cloudStorage.deleteItem(key);
    } else {
      localStorage.removeItem(key);
    }
  },
};
